import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { formatNumber } from "../../utils/common";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

function BarVeriticalSonndesfro({ data, t }) {
  const labels = data.map((item) => t(item.month.toString()) + " " + item.year);
  const dataObj = data.map((item) => Math.floor(item.result));

  const backgroundColors = dataObj.map((value) => "#0080B7");

  const chartData = {
    labels,
    datasets: [
      {
        label: t("resultsTitle"),
        data: dataObj,
        backgroundColor: backgroundColors,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 25, // adjust this value as needed to provide enough room for the labels
      },
    },
    scales: {
      x: {
        grid: {
          drawOnChartArea: false,
          drawBorder: false,
          display: false,
        },
        ticks: {
          color: "black",
        },
      },
      y: {
        ticks: {
          display: true,
        },
        grid: {
          drawBorder: false,
          display: false, // This hides the horizontal grid lines
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += formatNumber(context.parsed.y) + "%";
            }
            return label;
          },
        },
      },
      datalabels: {
        anchor: "end",
        align: "top",
        formatter: function (value, context) {
          return formatNumber(value);
        },
        color: "black",
      },
    },
  };

  return <Bar options={options} data={chartData} />;
}

export default BarVeriticalSonndesfro;
